<script lang="ts">
  import { createNewsDetailsUrl } from '$lib/utils/news';
  import Image from '$lib/components/Shared/Image.svelte';
  import { sendAnalyticsEvent } from '$lib/services/analytics';
  import { EventNames, EventSectionName } from '$lib/types/analytics';
  import Share from '../Shared/Share.svelte';
  import PlayCenterIcon from '$lib/assets/icons/PlayCenterIcon.svelte';
  import Modal from '../Shared/Modal/Modal.svelte';
  import VideoNotFound from '../Shared/VideoPlayer/VideoNotFound.svelte';
  import VideoPlayer from '../Shared/VideoPlayer/VideoPlayer.svelte';
  import { page } from '$app/stores';
  import { timeAgo } from '$lib/utils';

  export let heroImage: string;
  export let bgColor = '#ffffff';
  export let postId: string;
  export let headline: string;
  export let publisherLogo: string;
  export let publisherName: string;
  export let priority = false;
  export let category: string;
  export let showModal = false;
  export let videoUrl: string | null = '';
  export let sourceUrl = '';
  export let position: number;
  export let showShare = true;
  export let sectionName: EventSectionName = EventSectionName.NEWS_FEED_NEWSPAGE;
  export let publishDate = '';

  const handleClick = (position: number, headline: string, publisher: string, category: string) => {
    setShowModal();
    sendAnalyticsEvent(EventNames.CLICK_CARD, {
      section_name: sectionName,
      description: headline,
      publisher,
      category,
      card_position: position + 1
    });
  };

  const setShowModal = () => {
    showModal = true;
  };

  const url = createNewsDetailsUrl(category, postId);
</script>

<button
  class="wrapper-button-container"
  on:click={() => handleClick(position, headline, publisherName, category)}
>
  <article class="news-article">
    <div class="news-article-link">
      <div class="image-container" style="--bg-color: {bgColor}">
        <Image src={heroImage} alt={headline} {priority} />
        <div class="play-icon">
          <PlayCenterIcon width={30} height={30} />
        </div>
      </div>
      <div class="news-content">
        {#if $page.route.id === '/'}
          <div class="publisher-name">
            {publisherName.toUpperCase()}
            <div class="dot" />
            {timeAgo(publishDate)}
          </div>
        {/if}

        <h3 class="title text-limit">{headline}</h3>

        {#if showShare}
          <div class="icons-container">
            <slot />
            <Share {url} />
          </div>
        {/if}
      </div>
    </div>
  </article>
</button>
<Modal {showModal}>
  <div class="video-modal">
    {#if videoUrl !== null}
      <VideoPlayer
        posterImage={heroImage}
        bind:showModal
        {publisherLogo}
        {publisherName}
        {headline}
        {videoUrl}
        {sourceUrl}
        {postId}
        {position}
        {category}
      />
    {:else}
      <VideoNotFound bind:showModal />
    {/if}
  </div>
</Modal>

<style lang="scss">
  .news-article {
    padding: 12px 0;
  }

  .news-article-link {
    text-decoration: none;
    display: flex;
  }

  .image-container {
    position: relative;
    background-color: var(--bg-color);
    border-radius: 16px;
    overflow: hidden;
    min-width: 78px;
    height: 78px;
    max-width: 78px;
  }

  .news-content {
    margin-left: 16px;
    display: flex;
    align-items: start;
    flex-direction: column;
    width: 100%;
  }

  .title {
    font-size: var(--font-size-base);
    font-weight: var(--font-weight-semibold);
    line-height: 130%;
    color: var(--color-title);
    margin: 0;
  }

  .text-limit {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    word-break: break-word;
  }
  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .wrapper-button-container {
    background: none;
    color: inherit;
    border: none;
    width: 100%;
    padding: 0;
    cursor: pointer;
    outline: inherit;
    text-align: left;
  }

  .icons-container {
    align-self: flex-end;
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
    margin-top: 8px;
    margin-right: 20px;
  }

  .publisher-name {
    text-decoration: none;
    color: var(--color-text-secondary);
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 200% */
    opacity: 0.5;
    display: flex;
    align-items: center;
  }

  .dot {
    width: 3px;
    height: 3px;
    background: var(--color-white);
    opacity: 0.5;
    border-radius: 50%;
    margin: 0px 4px;
  }
</style>
